import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Form, Text, Util, Email, PostalCode, ConnectedDatePicker } from '@grandvisionhq/forms';
import { Alert } from '@grandvisionhq/iris-ui';
import { initialAnonymousForm } from '../../../constants/initial-form.js';
import { CancellationReasonFieldContainer } from '../components/CancellationReasonField/CancellationReasonFieldContainer.js';

const AnonymousCancelSubscriptionForm = ({ formRef , isSuccess , isUpdating , labels , onBlur , onChange , onSubmit , selectedCancellationType  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isSuccess ? /*#__PURE__*/ React.createElement(Alert, {
        variant: "success",
        title: labels.success.title,
        titleHeadingLevel: "h2"
    }, labels.success.description) : null, /*#__PURE__*/ React.createElement(Form, {
        className: "cancel-subscription-form",
        name: "cancel-subscription-form",
        initialFormState: initialAnonymousForm,
        onBlur: onBlur,
        onChange: onChange,
        onSubmit: onSubmit,
        ref: formRef,
        "aria-label": labels.formAriaLabel
    }, /*#__PURE__*/ React.createElement(Text, {
        id: "subscriptionNumber",
        label: labels.subscriptionNumber.label,
        placeholder: labels.subscriptionNumber.placeholder,
        errorMessage: labels.subscriptionNumber.errorMessage,
        validations: [
            Util.validations.isAlphanumeric
        ],
        required: true,
        "data-t": "subscription-number"
    }), /*#__PURE__*/ React.createElement(Email, {
        id: "email",
        label: labels.email.label,
        placeholder: labels.email.placeholder,
        errorMessage: labels.email.errorMessage,
        required: true
    }), /*#__PURE__*/ React.createElement(PostalCode, {
        label: labels.postalCode.label,
        placeholder: labels.postalCode.placeholder,
        errorMessage: labels.postalCode.errorMessage,
        required: true
    }), /*#__PURE__*/ React.createElement(ConnectedDatePicker, {
        name: "cancellationDate",
        className: "cancel-subscription-form__date-picker",
        label: labels.cancellationDate.label,
        placeholder: labels.cancellationDate.placeholder,
        errorMessage: labels.cancellationDate.errorMessage,
        minDate: new Date(),
        dateFormat: "dd MMMM yyyy",
        required: true,
        autoComplete: false
    }), /*#__PURE__*/ React.createElement(CancellationReasonFieldContainer, {
        selectedCancellationType: selectedCancellationType,
        required: true
    }), /*#__PURE__*/ React.createElement(Button, {
        caption: labels.submit,
        className: "cancel-subscription-form__submit",
        isLoading: isUpdating,
        type: "submit",
        disabled: isUpdating
    })));
};

export { AnonymousCancelSubscriptionForm };
//# sourceMappingURL=AnonymousCancelSubscriptionForm.js.map
